<template>
  <v-card flat style="border-radius:1px">
    <v-card-title primary-title class="pb-0">
      <v-row class="" align="center">
        <v-col class="pa-0" cols="10" sm="4" md="3">
          <div class="title mb-0">Telefones</div>
        </v-col>
        <v-col class="pa-0" cols="2">
          <v-btn v-if="!is_readonly" class="mx-4" text icon color="success" v-on:click="phones.push('')"><v-icon style="font-size: 30px">mdi-phone-plus</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class=" mt-2">
      <v-form v-if="!is_readonly" v-model="valid_phones" ref="formPhones">
        <v-row v-for="(phone, index) in phones" :key="'phe'+index" @keyup="$emit('update:phones', phones)" >
          <v-col cols="10" md="5" class="pa-0">
            <v-text-field :readonly="is_readonly" :rules="[rules.required]" v-model="phones[index]" prepend-icon="mdi-phone" v-mask='[mask_phone, mask_cellphone]'  label="Telefones"></v-text-field>
          </v-col>
          <v-col cols="2" class="pa-0">
            <v-btn v-if="!is_readonly" class="mx-4" text icon color="warning" :disabled="phones.length < 2 " @click="phones.splice(index, 1)"><v-icon style="font-size: 30px">mdi-phone-minus</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row v-if="is_readonly">
        <v-text-field single-line outlined v-for="(phone, index) in phones" :key="'phs'+index"  :readonly="is_readonly" :rules="[rules.required]" v-model="phones[index]" prepend-icon="mdi-phone" v-mask='[mask_phone, mask_cellphone]'  :label="'Telefone '+(index+1)"></v-text-field>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'InputPhone',
  directives: {
    mask,
  },
  props: {
    phones: {
      type: Array,
      default: () => {return [""]}
    },
    is_readonly:{
      type: Boolean,
      default: () => { return false }
    }
  },

  name: "input-phone",
  data() {
    return {
      mask_phone: '(##) ####-####',
      mask_cellphone:'(##) #####-####',
      valid_phones: true,
      rules: {
        required: v => !!v || 'Campo é necessário'}
        // phones:
    }

  },
  computed: {
    // clean_phones(){
    //   return phones.filter(obj=> obj !='')
    // }
  },
  methods: {
    parse_phone(){   
      // let ph =     
      this.$emit('update:phones', phones.filter(obj=> obj !=''))
    }
  },
  watch: {
    phones() {
      // parse_phone
    }
  },
};
</script>

<style scoped>
  p {
    background-color: blue;
  }
</style>